import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/nafath/check.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var checkNafath = (props) => __async(void 0, null, function* () {
  try {
    const lang = getLocaleOnly(props.locale);
    const data = yield fetchClient({
      url: "/nafath/check-status",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, props), { lang }))
      }
    });
    if (data.status === "WAITING") {
      return;
    }
    if (data.status !== "COMPLETED" || data.error) {
      const msg = data.error;
      throw new Error(msg || "Somthing went wrong");
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "checkNafathException",
      context: { extra: props }
    });
  }
});

export {
  checkNafath
};
//# sourceMappingURL=chunk-DWOMOZDJ.mjs.map